// extracted by mini-css-extract-plugin
export default {"title":"GripTeamDetailCard_title_vgx6j","spinAround":"GripTeamDetailCard_spinAround_R9Fsh"};